import {Component, OnInit} from "@angular/core";
import {GeneratorSentencesService} from "./generator-sentences.service";
import {groupGeneratorSentencesByKey} from "./group-generator-sentences-by-key";
import {ungroupSentenceGroups} from "./ungroup-sentence-groups";
import {finalize} from "rxjs/operators";
import {Notifications, NotificationType} from "../../../../../tools/notifications/notifications";
import {ExternalAnalysisType} from "../../../../hospitals/edit-hospital/hospital.details";
import {SupportedLanguagesProvider} from "../../../../../tools/supported-languages-provider";
import {LanguageDefinition} from "../../../../../tools/language-definition";

@Component({
    selector: "app-generator-sentences",
    templateUrl: "./generator-sentences.component.html",
    standalone: false
})
export class GeneratorSentencesComponent implements OnInit {

  sentences!: GeneratorSentences;

  sentenceGroups: SentenceGroupsByAnalysisType = {cas: [], cardiologs: []};
  activeExternalAnalysisType: ExternalAnalysisType = "CAS";
  savingInProgress = false;
  gettingSentencesFailed = false;

  readonly supportedLanguages: LanguageDefinition[];

  get groups(): SentenceGroup[] {
    return this.activeExternalAnalysisType === "CAS"
      ? this.sentenceGroups.cas
      : this.sentenceGroups.cardiologs;
  }

  constructor(
    readonly generatorSentencesService: GeneratorSentencesService,
    readonly notifications: Notifications,
    readonly supportedLanguagesProvider: SupportedLanguagesProvider
  ) {
    this.supportedLanguages = this.supportedLanguagesProvider.getLanguages();
  }

  ngOnInit(): void {
    this.generatorSentencesService
      .getGeneratorSentences()
      .subscribe({
        next: generatorSentences => {
          this.sentences = generatorSentences;
          this.sentenceGroups = groupGeneratorSentencesByKey(generatorSentences);
        },
        error: () => this.gettingSentencesFailed = true
      });
  }

  showSentencesFor(externalAnalysisType: ExternalAnalysisType) {
    this.activeExternalAnalysisType = externalAnalysisType;
  }

  saveSentences() {
    this.savingInProgress = true;

    this
      .generatorSentencesService
      .setGeneratorSentences({
        sentences: ungroupSentenceGroups(this.sentenceGroups)
      })
      .pipe(finalize(() => this.savingInProgress = false))
      .subscribe({
        next: () => this.notifications.addNotification(
          NotificationType.OK,
          "generatorSentencesSaveSuccessMessage"
        ),
        error: () => this.notifications.addNotification(
          NotificationType.ERROR,
          "generatorSentencesSaveFailureMessage"
        )
      });
  }

  setSentence(group: SentenceGroup, code: string, event: Event) {
    group.sentencesByLanguage[code] = (event.target as HTMLInputElement).value;
  }
}

export interface GeneratorSentences {
  readonly sentences: GeneratorSentence[];
}

export interface GeneratorSentence {
  readonly key: string;
  readonly language: string;
  readonly sentence: string;
  readonly externalAnalysisType: ExternalAnalysisType;
}

export interface SentenceGroup {
  readonly key: string;
  sentencesByLanguage: Record<string, string>;
}

export interface SentenceGroupsByAnalysisType {
  cas: SentenceGroup[];
  cardiologs: SentenceGroup[];
}
